<template>
  <div class="promo-box-wrapper">
    <div :class="{'in-cart': cart}" class="promo-box flex" data-name="subscription">
      <div class="promo-box-image flex items-center justify-center">
        <img :height="promos[promoType].size[1]" :src="promoIcon" :width="promos[promoType].size[0]" alt="">
        </img></div>
      <div v-if="promoType === 'subscription'" class="promo-box-info">
        <h4>{{ $t("components.diagram.PromoBox.download-any-slide") }}</h4>
        <p>
          {{ $t("components.diagram.PromoBox.with") }}
          <NuxtLink :to="localePath('/subscription')" @click.native="e => trackClick('Subscription')">
            {{ $t("components.diagram.PromoBox.subscription") }}
          </NuxtLink>
          {{ $t("components.diagram.PromoBox.you-can-pick-and-choose-slides-from-all-decks") }}.
          {{ $t("components.diagram.PromoBox.prices-start-from-dollar29month") }}.
          {{ $t("components.diagram.PromoBox.cancel-anytime") }}
        </p>
      </div>
      <div v-else="" class="promo-box-info">
        <h4 v-html="promoHeader"/>
        <p v-html="promoText"/>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {onMounted} from 'vue'

const {analytics} = useAnalytics()
const localePath = useLocalePath()

interface Props {
  cart?: boolean
  price?: number
}

const {cart = false, price = 29} = defineProps<Props>()

const {t} = useNuxtApp().$i18n

const promos = {
  standard: {
    img: '/images/icon-gift.svg',
    size: [43, 45],
    cartImg: '/images/icon-savings-white.svg',
    text: `${t('components.diagram.PromoBox.buy-this-diagram-today')} <strong>${t('components.diagram.PromoBox.30-slides-for-free')}</strong> ${t('components.diagram.PromoBox.with-one-month-subscription')}.`,
    cartText: `${t('components.diagram.PromoBox.one-month-access')}. ${t('components.diagram.PromoBox.up-to')} <strong>${t('components.diagram.PromoBox.30-slides')}</strong> ${t('components.diagram.PromoBox.extra')}!`
  },
  premium: {
    img: '/images/icon-diamond.svg',
    size: [50, 40],
    cartImg: '/images/icon-diamond-white.svg',
    text: `${t('components.diagram.PromoBox.buy-this-diagram-today')} <strong>${t('components.diagram.PromoBox.100-slides-for-free')}</strong> ${t('components.diagram.PromoBox.with-one-month-premium')}.`,
    cartText: `${t('components.diagram.PromoBox.one-month-access-to-premium')}. ${t('components.diagram.PromoBox.up-to')} <strong>${t('components.diagram.PromoBox.100-slides')}</strong> ${t('components.diagram.PromoBox.extra')}!`
  },
  subscription: {
    img: '/images/icon-savings.svg',
    cartImg: '/images/icon-savings-white.svg',
    size: [52, 53]
  },
  'savings-cart': {
    text: t('components.diagram.PromoBox.you-are-gaining-5-credits')
  },
  'premium-cart': {
    text: t('components.diagram.PromoBox.you-are-gaining-access-to-premium')
  }
}
const promoIcon = computed(() => {
  if (cart) {
    return promos[promoType.value].cartImg
  } else {
    return promos[promoType.value].img
  }
})

const promoType = computed(() => {
  if (price > 99) {
    return 'premium'
  } else if (price > 58) {
    return 'standard'
  } else {
    return 'subscription'
  }
})

const promoText = computed(() => {
  if (cart) {
    return promos[promoType.value].cartText
  } else {
    return promos[promoType.value].text
  }
})

const promoHeader = computed(() => {
  return promos[promoType.value].header || t('components.diagram.PromoBox.free-add-on-to-this-product')
})

const trackClick = (event: string) => {
  analytics.track(event, {event_category: 'Promo banner'})
}

onMounted(() => {
  analytics.track(`Display ${promoType.value}`, {event_category: 'Promo banner'})
})
</script>

<style scoped>
.promo-box {
  border: 3px solid #fff;
  background-color: #EDEDED;
  border-radius: 10px;
  margin-bottom: 20px;
}

.promo-box.in-cart {
  border: 2px solid #D7D7D7;
  background-color: #fff;
  border-radius: 10px;
  margin-bottom: 0;
  margin-top: 16px;
  overflow: hidden;
}

.promo-box.in-cart .promo-box-image {
  background-color: #D7D7D7;
  width: 93px;
}

.promo-box.in-cart .promo-box-info {
  width: calc(100% - 93px);
  padding: 12px 12px 12px 30px;
}

.promo-box-image {
  width: 70px;
  background-color: #fff;
}

.promo-box-info {
  width: calc(100% - 70px);
  padding: 10px 12px 12px 12px;
}

.promo-box h4 {
  font-weight: 600;
  font-size: 20px;
  line-height: 27px;
  margin: 0 0 4px 0;
}

.promo-box p {
  font-size: 16px;
  line-height: 22px;
  margin-bottom: 0;
}

@media (max-width: 768px) {
  .promo-box-wrapper {
    padding-left: 24px;
    padding-right: 24px;
  }
}
</style>
